import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { ExecutionLogDetail } from '~/components/settings/admin/dataSubscriptions/ExecutionLogDetail';

export const Route = createFileRoute(
  '/(main)/settings/admin/data-subscription-logs/$logId/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin/data-subscription-logs/$logId',
    vestigasSupportAccess: true,
  }),
  component: ExecutionLogDetail,
});

export const ADMIN_DATA_SUBSCRIPTION_LOG_DETAIL = buildRouteExport({
  Route,
});
